import type { Translation } from '../types.ts';
import type en from '../en/media.ts';

export default {
    upload: {
        stalled: 'De server meldt niets meer over deze upload.',
        finalizeFailed: 'Uploaden is mislukt tijdens het afronden.',
    },
    index: {
        title: 'Media',
        searchPlaceholder: 'Zoek op bestandsnaam',
        clearSelection: 'Wissen',
        selectAll: 'Alles selecteren',
        done: 'Klaar',
        savingOrder: 'Volgorde opslaan…',
        clearSearchToReorder: 'Wis de zoekopdracht om de volgorde te wijzigen',
        dragToReorder: 'Sleep om de volgorde te wijzigen',
        select: 'Selecteren',
        dismiss: 'Sluiten',
        empty: 'Nog geen media in deze map. Upload een bestand om te beginnen.',
        notConverted: '{name} kon niet worden geconverteerd, dus het origineel is bewaard. Het speelt misschien niet in elke browser af. Exporteer het opnieuw als standaard-MP4 en upload het nogmaals.',
        usageCheckFailed: 'Kon niet controleren waar deze bestanden worden gebruikt, dus er is niets verwijderd. {message}',
        deletedFiles: '{n} bestanden verwijderd. | {n} bestand verwijderd. | {n} bestanden verwijderd.',
        deleteFailed: '{n} kon niet worden verwijderd: {names}. | {n} konden niet worden verwijderd: {names}.',
        deleteMissing: '{n} was al verdwenen. | {n} waren al verdwenen.',
        inUse: 'Deze bestanden worden gebruikt op de site. Er is nog niets verwijderd.',
    },
    edit: {
        libraryRoot: 'Bibliotheek (hoofdmap)',
        confirmDelete: "\"{name}\" verwijderen? Pagina's die er nog naar verwijzen, tonen dan een kapotte afbeelding.",
        pathCopied: 'Pad gekopieerd',
        urlCopied: 'URL gekopieerd',
        snippetCopied: 'Snippet gekopieerd',
        copyFailed: 'Kopiëren naar het klembord is mislukt. Selecteer de tekst en kopieer hem zelf.',
        path: 'Pad',
        fullUrl: 'Volledige URL',
        useInTemplate: 'Gebruiken in een template',
        notConverted: 'Deze video kon niet worden geconverteerd, dus het originele bestand is bewaard. Hij speelt misschien niet in elke browser af. Exporteer hem opnieuw als standaard-MP4 en upload hem nogmaals.',
        filename: 'Bestandsnaam',
        filenameHint: "Hernoemen past elke verwijzing in de pagina's van deze website aan.",
        alt: 'Alt-tekst',
        altHint: 'Beschrijft de afbeelding voor schermlezers.',
        caption: 'Bijschrift',
        folder: 'Map',
        folderHint: 'Waar dit bestand in de bibliotheek staat. Alleen voor de ordening: de URL van het bestand verandert niet.',
    },
    picker: {
        searchPlaceholder: 'Zoeken…',
        empty: 'Geen media in deze map. Upload een bestand om te beginnen.',
        notImage: '{name}: geen afbeelding',
        notVideo: '{name}: geen video',
        notConverted: 'Deze video kon niet worden geconverteerd en speelt misschien niet overal af.',
    },
    folders: {
        library: 'Bibliotheek',
        newFolder: 'Nieuwe map',
        newFolderPrompt: 'Naam van de nieuwe map',
        renamePrompt: 'Map hernoemen',
        rename: 'Hernoemen',
        confirmDelete: 'Map "{name}" verwijderen? De bestanden en submappen erin gaan naar de bovenliggende map.',
    },
    bulkDelete: {
        title: '{n} bestanden verwijderen | {n} bestand verwijderen | {n} bestanden verwijderen',
        checking: 'Controleren waar deze bestanden worden gebruikt…',
        noneInUse: 'Geen van deze bestanden wordt gebruikt op de site. Verwijderen kan niet ongedaan worden gemaakt.',
        inUse: '{n} van deze {total} bestanden wordt nog gebruikt op de site. | {n} van deze {total} bestanden worden nog gebruikt op de site.',
        warning: "Verwijderen haalt ze niet weg uit de pagina's hieronder. Die pagina's blijven verwijzen naar een bestand dat er niet meer is en tonen een lege plek waar de afbeelding stond. Dit kan niet ongedaan worden gemaakt, en niets op de pagina vertelt wat er is gebeurd.",
        usedIn: 'Op {n} plekken gebruikt | Op {n} plek gebruikt | Op {n} plekken gebruikt',
        otherUnused: 'De andere {n} bestanden worden nergens gebruikt. | Het andere bestand wordt nergens gebruikt. | De andere {n} bestanden worden nergens gebruikt.',
        acknowledge: "Ik begrijp dat {n} bestand nog in gebruik is en dat de pagina's hierboven kapotgaan. | Ik begrijp dat {n} bestanden nog in gebruik zijn en dat de pagina's hierboven kapotgaan.",
        kinds: {
            page: 'Pagina',
            pageTranslation: 'Paginavertaling',
            article: 'Artikel',
            product: 'Product',
            category: 'Categorie',
            faq: 'FAQ-vraag',
            landingRow: 'Landingspagina',
            landingTemplate: 'Landingstemplate',
            portfolio: 'Portfoliocollectie',
        },
    },
} satisfies Translation<typeof en>;
